import React, { useEffect, useState } from 'react';
import { Box, CardActionArea, CardContent, Typography } from '@mui/material';
import { ServerApiUrl } from 'api';
import OneOncologyLogo from 'assets/one-oncology-logo-small.svg';
import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import LiveHelpOutlinedIcon from '@mui/icons-material/LiveHelpOutlined';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import { useNavigate } from 'react-router-dom';
import { CardLink, HelpPageContainer } from './HelpCenter.styled';
import { useOktaAuth } from '@okta/okta-react';
import axios from 'axios';
import MovieIcon from '@mui/icons-material/Movie';

export const HelpCenterPage: React.FC = () => {
  const navigate = useNavigate();
  const { authState } = useOktaAuth();
  const [blobData, setBlobData] = useState();

  const handleUserGuide = async () => {
    const response = await axios.get(
      ServerApiUrl + 'pdf/oneAnalyticsUserGuide',
      {
        method: 'GET',
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${authState?.accessToken?.accessToken}`, // Ensure token is included
          'Content-Type': 'application/pdf',
        },
      }
    );

    const reader = new FileReader();
    reader.onloadend = () => {
      const jsonData = JSON.parse(reader.result as string);
      setBlobData(jsonData.fileContents);
    };

    reader.onerror = error => {
      console.error('Blob read error:', error);
    };

    const blob = response.data;
    reader.readAsText(blob);
  };

  const handleUserAccess = () => {
    const userRequesetUrl =
      'https://forms.monday.com/forms/989f3d1af16e7a86f37abfb53c997c45?r=use1';

    window.open(userRequesetUrl, '_blank');
  };

  useEffect(() => {
    if (blobData) {
      const pdfBase64 = blobData; // Assuming the base64 string is in 'pdfData'
      const byteCharacters = atob(pdfBase64);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: 'application/pdf' });
      const url = URL.createObjectURL(blob); // Create object URL from the Blob
      window.open(url, '_blank');
    }
  }, [blobData]);

  const handleRequestSupportButton = () => {
    navigate('/requestSupport');
  };

  return (
    <HelpPageContainer>
      <Box display="flex" alignItems="center">
        <Box
          component="img"
          sx={{ color: '#0EAA7C', height: '7em' }}
          src={OneOncologyLogo}
        />
        <Typography variant="h4">Help Center</Typography>
      </Box>
      <Box display="flex" gap="2em">
        <CardLink>
          <CardActionArea
            onClick={handleUserGuide}
            sx={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <CardContent>
              <Typography variant="h6" component="div">
                View our user guide
              </Typography>
            </CardContent>
            <ContactPageOutlinedIcon
              sx={{
                height: '5em',
                width: '5em',
                color: '#24806e',
                padding: '1em',
              }}
            />
          </CardActionArea>
        </CardLink>
        <CardLink>
          <CardActionArea
            sx={{
              display: 'flex',
              flexDirection: 'column',
            }}
            onClick={handleRequestSupportButton}
          >
            <CardContent>
              <Typography variant="h6" component="div">
                Request support
              </Typography>
            </CardContent>
            <LiveHelpOutlinedIcon
              sx={{
                height: '5em',
                width: '5em',
                color: '#24806e',
                padding: '1em',
              }}
            />
          </CardActionArea>
        </CardLink>
        <CardLink>
          <CardActionArea
            sx={{
              display: 'flex',
              flexDirection: 'column',
            }}
            onClick={handleUserAccess}
          >
            <CardContent>
              <Typography variant="h6" component="div">
                User access request
              </Typography>
            </CardContent>
            <PersonAddAlt1OutlinedIcon
              sx={{
                height: '5em',
                width: '5em',
                color: '#24806e',
                padding: '1em',
              }}
            />
          </CardActionArea>
        </CardLink>

        <CardLink>
          <CardActionArea
            sx={{
              display: 'flex',
              flexDirection: 'column',
            }}
            onClick={() => navigate('/trainingVideos')}
          >
            <CardContent>
              <Typography variant="h6" component="div">
                Training Videos
              </Typography>
            </CardContent>
            <MovieIcon
              sx={{
                height: '5em',
                width: '5em',
                color: '#24806e',
                padding: '1em',
              }}
            />
          </CardActionArea>
        </CardLink>
      </Box>
    </HelpPageContainer>
  );
};
